(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-banner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cookie-banner')) {
    /**
     * Cookie consent banner. Saves the visitor's choice in localStorage and forwards it
     * to Shopify's Customer Privacy API so platform analytics and pixels follow it.
     */
    class CookieBanner extends HTMLElement {
      static storageKey = 'nivedita-cookie-consent';
      static categories = ['preferences', 'analytics', 'marketing'];

      /** @type {AbortController | undefined} */
      #controller;
      /** @type {HTMLElement | null} */
      #returnFocusTo = null;
      /** @type {number | undefined} */
      #hideTimer;

      connectedCallback() {
        this.#controller?.abort();
        this.#controller = new AbortController();
        const { signal } = this.#controller;

        this.addEventListener('click', this.#handleClick, { signal });
        this.addEventListener('keydown', this.#handleKeydown, { signal });
        document.addEventListener('click', this.#handleReopen, { signal });

        this.#init();
      }

      disconnectedCallback() {
        this.#controller?.abort();
        window.clearTimeout(this.#hideTimer);
      }

      async #init() {
        if (this.dataset.designMode === 'true') {
          this.open();
          return;
        }

        if (this.#readSaved()) return;

        const privacy = await this.#loadPrivacyApi();
        const existing = privacy?.currentVisitorConsent?.();
        const decided =
          existing && CookieBanner.categories.some((category) => existing[category] === 'yes' || existing[category] === 'no');

        if (decided) return;

        this.open();
      }

      /** Opens the banner on the summary view, or on the preferences view when requested. */
      open(view = 'summary') {
        window.clearTimeout(this.#hideTimer);
        this.#syncSwitches();
        this.#showView(view, false);
        this.hidden = false;
        // Only take focus when the visitor asked for the panel; the first-visit banner stays non-intrusive.
        if (view === 'preferences') this.#showView(view);
        requestAnimationFrame(() => {
          this.dataset.state = 'open';
        });
      }

      close() {
        this.dataset.state = 'closed';
        const duration = parseFloat(getComputedStyle(this).getPropertyValue('--cookie-banner-duration')) || 0;

        this.#hideTimer = window.setTimeout(() => {
          this.hidden = true;
        }, duration * 1000);

        this.#returnFocusTo?.focus();
        this.#returnFocusTo = null;
      }

      /** @param {MouseEvent} event */
      #handleClick = (event) => {
        if (!(event.target instanceof Element)) return;

        const button = event.target.closest('[data-action]');
        if (!(button instanceof HTMLElement)) return;

        switch (button.dataset.action) {
          case 'accept':
            this.#save({ preferences: true, analytics: true, marketing: true });
            break;
          case 'decline':
            this.#save({ preferences: false, analytics: false, marketing: false });
            break;
          case 'save':
            this.#save(this.#readSwitches());
            break;
          case 'manage':
            this.#showView('preferences');
            break;
          case 'back':
            this.#showView('summary');
            break;
        }
      };

      /** @param {KeyboardEvent} event */
      #handleKeydown = (event) => {
        if (event.key === 'Escape' && this.#currentView() === 'preferences') {
          event.stopPropagation();
          this.#showView('summary');
        }
      };

      /** Lets any `[data-cookie-preferences]` link or button reopen the preferences panel. */
      #handleReopen = (event) => {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest('[data-cookie-preferences]');
        if (!(trigger instanceof HTMLElement)) return;

        event.preventDefault();
        this.#returnFocusTo = trigger;
        this.open('preferences');
      };

      /**
       * @param {'summary' | 'preferences'} view
       * @param {boolean} [moveFocus]
       */
      #showView(view, moveFocus = true) {
        for (const panel of this.querySelectorAll('[data-view]')) {
          if (panel instanceof HTMLElement) panel.hidden = panel.dataset.view !== view;
        }

        if (!moveFocus) return;

        const target = this.querySelector(view === 'preferences' ? '#CookiePreferencesTitle' : '[data-action="manage"]');
        if (target instanceof HTMLElement) target.focus();
      }

      #currentView() {
        const visible = this.querySelector('[data-view]:not([hidden])');
        return visible instanceof HTMLElement ? visible.dataset.view : undefined;
      }

      #switches() {
        return /** @type {HTMLInputElement[]} */ ([...this.querySelectorAll('input[data-category]')]);
      }

      #readSwitches() {
        /** @type {Record<string, boolean>} */
        const consent = {};
        for (const input of this.#switches()) consent[input.dataset.category ?? ''] = input.checked;
        return consent;
      }

      #syncSwitches() {
        const saved = this.#readSaved();
        for (const input of this.#switches()) {
          input.checked = Boolean(saved?.[input.dataset.category ?? '']);
        }
      }

      /** @returns {Record<string, boolean> | null} */
      #readSaved() {
        try {
          const raw = window.localStorage.getItem(CookieBanner.storageKey);
          if (!raw) return null;
          const parsed = JSON.parse(raw);
          return parsed && typeof parsed === 'object' ? parsed : null;
        } catch {
          return null;
        }
      }

      /** @param {Record<string, boolean>} consent */
      async #save(consent) {
        try {
          window.localStorage.setItem(
            CookieBanner.storageKey,
            JSON.stringify({ ...consent, savedAt: new Date().toISOString() })
          );
        } catch {
          // Storage can be unavailable in private browsing; the platform API below still records consent.
        }

        this.close();

        const privacy = await this.#loadPrivacyApi();
        if (!privacy?.setTrackingConsent) return;

        try {
          privacy.setTrackingConsent(
            {
              preferences: Boolean(consent.preferences),
              analytics: Boolean(consent.analytics),
              marketing: Boolean(consent.marketing),
              sale_of_data: Boolean(consent.marketing),
            },
            () => document.dispatchEvent(new CustomEvent('cookie-consent:updated', { detail: consent }))
          );
        } catch (error) {
          console.error('Cookie banner: unable to record consent with Shopify', error);
        }
      }

      /** Loads Shopify's consent-tracking API when the storefront exposes it. */
      #loadPrivacyApi() {
        const shopify = /** @type {any} */ (window).Shopify;
        if (shopify?.customerPrivacy) return Promise.resolve(shopify.customerPrivacy);
        if (typeof shopify?.loadFeatures !== 'function') return Promise.resolve(null);

        return new Promise((resolve) => {
          shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (/** @type {unknown} */ error) => {
            resolve(error ? null : shopify.customerPrivacy ?? null);
          });
        });
      }
    }

    customElements.define('cookie-banner', CookieBanner);
  }
  } catch(e) { console.error(e); }
})();

})();
